<div class="search-container" #searchContainer>
  <div class="input-wrapper">
    <app-filter-product (searchEvent)="search($event)" (click)="openOverlayIfHasValue()"></app-filter-product>
  </div>

  @if (isOverlayOpen) {
    <div class="search-results-overlay">
      @if (filteredResults.length > 0) {
        <h6 class="odx-title-6 search-results-label" i18n="@@productList.header.searchResults">Suchergebnisse</h6>
        @for (product of filteredResults; track product) {
          <div>
            <hr />
            <app-fgds-product-search-item
              [product]="product"
              [canAddToFloorplan]="floorplanProductTypes.includes(product.type)"
              [isShownOnProductList]="true"
              (addToBom)="addProductToBom(product)"
            ></app-fgds-product-search-item>
          </div>
        }
      } @else {
        <div class="no-products-container">
          <div class="no-products-message" i18n="@@floorplan.productSearch.noResults">Keine Suchergebnisse</div>
        </div>
      }
    </div>
  }
</div>
